import { ChangeDetectionStrategy, Component, DestroyRef, inject, Inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@core/auth';
import { DialogService } from '@shared/services';
import { TypedRoute } from '@shared/utils';
import { switchMap } from 'rxjs';

@Component({
  selector: 'app-email-verify',
  templateUrl: './email-verify.component.html',
  styleUrl: './email-verify.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailVerifyComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  constructor(
    @Inject(ActivatedRoute) private readonly route: TypedRoute<{ token: string }>,
    private readonly authService: AuthService,
    private readonly dialogService: DialogService,
  ) {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data) => {
      const token = data.token;
      if (!token) {
        this.redirectToLogin();
        return;
      }
      this.authService
        .logOutWithoutRedirect()
        .pipe(switchMap(() => this.authService.emailVerifyJWT(token)))
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: () => {
            this.redirectToLogin();
            this.dialogService.showEmailVerificationSuccessDialog();
          },
          error: (err) => {
            this.redirectToLogin();
            if (err?.status === 401 && err.error?.meta?.is_authenticated === false) {
              this.dialogService.showEmailVerificationSuccessDialog();
              return;
            }
            this.dialogService.showEmailVerificationFailedDialog();
          },
        });
    });
  }

  private redirectToLogin(): void {
    this.router.navigate(['/login']);
  }
}
